import React from 'react';
import { setCurrentView } from 'core/utils';
import { StatusChangeViewStore } from 'modules/order/stores';
import { StatusChangeTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new StatusChangeViewStore(rootStore, componentProps),
	'statusChangeViewStore'
)
class StatusChange extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <StatusChangeTemplate {...this.props} />;
	}
}

export default StatusChange;



// WEBPACK FOOTER //
// ./src/modules/order/pages/StatusChange.jsx